import React, { useEffect, useMemo } from "react";
import { ModuleAccordionGroup, SIDE_TABLE_COLUMN_TYPES, tableSideColumnMapper } from "@loanbossinc/component-library";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { AccordionSection } from "component-lib/AccordionSection";

import { DEAL_SECTION_KEYS } from "../deal.constants";
import { actionCreators as integrationsActionCreators } from "../../../components/Admin/VendorIntegrations/vendorIntegrations.store";

import { SubsectionWrapper } from "./styles";

const DEFAULT_WIDTH = 138;

const getRows = (companyIntegrations, dealProperties, vendorProperiesForDeal) => {
  const getVendorPropertyId = (propertyId, integration) => {
    const vendorPropMappings = vendorProperiesForDeal.find(vp => vp.propertyId === propertyId && integration.vendorId === vp.vendorId);

    return vendorPropMappings ? vendorPropMappings.vendorPropertyId : null;
  };

  const rows = {};
  companyIntegrations.forEach(integration => {
    rows[integration.vendorName] = {
      cells: [
        {
          type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
          colSpan: 2,
          label: `${integration.vendorName} property ids`,
          Cell: tableSideColumnMapper,
          className: "subsection"
        }
      ]
    };
    dealProperties.forEach(property => {
      rows[`${integration.vendorName}-${property.name}`] = {
        cells: [
          {
            type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
            width: DEFAULT_WIDTH,
            label: property.name,
            Cell: tableSideColumnMapper
          },
          {
            type: "TEXT",
            map: () => getVendorPropertyId(property.id, integration),
            Cell: tableSideColumnMapper
          }
        ]
      };
    });
  });

  return rows;
};

const DealIntegrations = props => {
  const {
    dealId,
    history,
    company,
    companyIntegrations,
    vendorProperiesForDeal,
    getVendorIntegrationsForCompany,
    getVendorPropertiesIds,
    shouldExpandAll,
    shouldCollapseAll,
    onToggleExpandAll,
    onToggleCollapseAll
  } = props;

  const deal = props.data;

  useEffect(() => {
    getVendorIntegrationsForCompany({ companyId: company.id });
    getVendorPropertiesIds({ dealId, companyId: company.id });
  }, []);

  const rows = useMemo(() => {
    if (companyIntegrations && vendorProperiesForDeal && deal) {
      return getRows(companyIntegrations, deal.properties, vendorProperiesForDeal);
    }

    return {};
  }, [companyIntegrations, vendorProperiesForDeal, deal]);

  if (companyIntegrations && !companyIntegrations.length) {
    return null;
  }

  return (
    <ModuleAccordionGroup
      shouldExpandAll={shouldExpandAll}
      shouldCollapseAll={shouldCollapseAll}
      onToggleExpandAll={onToggleExpandAll}
      onToggleCollapseAll={onToggleCollapseAll}
      groups={[
        {
          title: "Integrations",
          key: DEAL_SECTION_KEYS.INTEGRATIONS,
          isExpandable: true,
          isTitleGroup: false,
          buttonLabel: "Edit Details",
          showEditButton: true,
          onClick: () => history.push(`/deal/${dealId}/edit/${DEAL_SECTION_KEYS.INTEGRATIONS}`),
          sections: companyIntegrations &&
            vendorProperiesForDeal && [
              <SubsectionWrapper>
              <AccordionSection rows={rows} />
            </SubsectionWrapper>
          ]
        }
      ]}
    />
  );
};

const mapStateToProps = ({ vendorIntegrations }) => ({ ...vendorIntegrations });

const mapDispatchToProps = dispatch => bindActionCreators({ ...integrationsActionCreators }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(DealIntegrations);
